<pbc-filter [config]="ZeitUnterartsFilterConfig" [filter]="zeitUnterarts.filter$ | async" (filterChange)="zeitUnterarts.filter$.next($event)"></pbc-filter>
